import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography, Card, Alert, Paper } from '@mui/material';
// components
import Iconify from '../components/iconify';
// sections
import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
  AppExtraSummary,
} from '../sections/@dashboard/app';
import api from '../api';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { useDispatch } from 'react-redux';
import DepositHistory from 'src/sections/@dashboard/dashboard/DepositHistory';
import BidHistory from 'src/sections/@dashboard/dashboard/BidHistory';
import BidPage from './BidPage';
import WalletHistoryPage from './WalletHistoryPage';
import { da } from 'date-fns/locale';
import BidHistoryByGameType from 'src/sections/@dashboard/dashboard/BidHistoryByGameType';
import WinHistoryByGameAndDate from 'src/sections/@dashboard/dashboard/WinHistoryByGameAndDate';
import WinnersListPage from './WinnersListPage';

// ----------------------------------------------------------------------

export default function DashboardAppPage({ url, isUserInfo }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAllDashboardData = async () => {
    !isUserInfo && dispatch(loadingStartAction());
    const response = await api.get(url || '/dashboard-stats');

    setData(response.data);
    setLoading(false);
    dispatch(loadingStopAction());
  };

  useEffect(() => {
    getAllDashboardData();
  }, []);

  let diffAmt = parseInt(data.totalOverallPoints) - parseInt(data.totalWinPointsOverall);
  let diffAmtToday = parseInt(data.totalPointsToday) - parseInt(data.totalWinPointsToday);
  if (loading) return <h1>Loading</h1>;
  return (
    <>
      <Helmet>
        <title> Dashboard | Minimal UI </title>
      </Helmet>

      <Container maxWidth="xl">
        {/* <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back
        </Typography> */}

        <Grid container spacing={3}>
          {!isUserInfo && (
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Approved Users"
                total={Number(data?.approvedUserCount) || 0}
                redirectTo="/admin/user"
                color="info"
                icon={'ant-design:apple-filled'}
              />
            </Grid>
          )}

          {!isUserInfo && (
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Un-Approved Users"
                redirectTo="/admin/user"
                total={Number(data?.unApprovedUserCount) || 0}
                color="success"
                icon={'ant-design:apple-filled'}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Total Bids Amount"
              redirectTo="/admin/game-bids"
              total={Number(data?.totalPointsToday) || 0}
              color="warning"
              icon={'ant-design:windows-filled'}
              currency="₹"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              redirectTo="/admin/master-game"
              title="Total Games"
              total={Number(data?.totalGames) || 0}
              color="warning"
              icon={'ant-design:windows-filled'}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              redirectTo="/admin/wallet-requests"
              title="Panding Withdraw Requests"
              total={Number(data.totalWithdrawals) || 0}
              color="error"
              icon={'ant-design:bug-filled'}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={9}></Grid>

          <Grid item xs={12} sm={6} md={6}>
            <Paper variant="outlined" square sx={{ px: 1, py: 1 }}>
              <Typography>All Time</Typography>
              <Alert sx={{ mx: 1, my: 1 }} variant="outlined" severity="success">
                <Typography>
                  <b>Total Bid</b> - {data.totalOverallPoints}
                </Typography>
              </Alert>
              <Alert sx={{ mx: 1, my: 1 }} variant="outlined" severity="warning">
                <Typography>
                  <b>Total Win</b> - {data.totalWinPointsOverall}
                </Typography>
              </Alert>
              <Alert sx={{ mx: 1, my: 1 }} variant="filled" severity="success">
                <Typography>
                  <b>Total Profit Amount - </b> {diffAmt > 0 ? diffAmt : 0}
                </Typography>
              </Alert>
              <Alert sx={{ mx: 1, my: 1 }} variant="filled" severity="error">
                <Typography>
                  <b>Total Loss Amount </b> {diffAmt < 0 ? diffAmt : 0}
                </Typography>
              </Alert>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <Paper variant="outlined" square sx={{ px: 1, py: 1 }}>
              <Typography>Today</Typography>
              <Alert sx={{ mx: 1, my: 1 }} variant="outlined" severity="success">
                <Typography>
                  <b>Today Total Bid</b> - {data.totalPointsToday}
                </Typography>
              </Alert>
              <Alert sx={{ mx: 1, my: 1 }} variant="outlined" severity="warning">
                <Typography>
                  <b>Today Total Win</b> - {data.totalWinPointsToday}
                </Typography>
              </Alert>
              <Alert sx={{ mx: 1, my: 1 }} variant="filled" severity="success">
                <Typography>
                  <b>Today Total Profit Amount - </b> {diffAmtToday > 0 ? diffAmtToday : 0}
                </Typography>
              </Alert>
              <Alert sx={{ mx: 1, my: 1 }} variant="filled" severity="error">
                <Typography>
                  <b>Today Total Loss Amount </b> {diffAmtToday < 0 ? diffAmtToday : 0}
                </Typography>
              </Alert>
            </Paper>
          </Grid>
        </Grid>

        <>
        <Grid container spacing={3} mt={5}>
            <WalletHistoryPage falseLoading type="dashboard" />
          </Grid>

          <Grid container spacing={3} mt={5}>
            <BidPage falseLoading />
          </Grid>

          <Grid container spacing={3} mt={5}>
            <WinnersListPage falseLoading />
          </Grid>
      
        </>
        <br />
        <Grid item xs={12} sm={12} md={12}>
          <AppExtraSummary icon={'ant-design:android-filled'} color="info">
            <h4>Market Bid By Game Type</h4>
            <BidHistoryByGameType />
          </AppExtraSummary>
        </Grid>
      </Container>
    </>
  );
}
